import { gql } from "@apollo/client";

export default gql`
  query getComplianceProgramReportingViews(
    $complianceProgramId: Int!
    $assessmentType: AssessmentType!
  ) {
    complianceProgramReportingViews(
      complianceProgramId: $complianceProgramId
      assessmentType: $assessmentType
    ) {
      edges {
        node {
          id
          name
          viewOptions
        }
      }
    }
  }
`;
